<template>
  <div class="index course-info-content">
    <br />
    <div class="doList">
      <div class="btn-top">
        <el-button type="default" v-if="showPubG && this.checkPublicTest()" plain class="testBtn-test" style="
            width: 104px;
            height: 34px;
            background: #0bcb90;

            border-radius: 4px !important;
            color: #ffffff;
          " @click="pubG()">正式发布</el-button>
        <el-button type="default" :disabled="true" v-if="showPub && this.checkPublicTest()" plain class="testBtn-test"
          style="
            width: 104px;
            height: 34px;
            background: #dfe0e2;

            border-radius: 4px !important;
            color: #ffffff;
          " @click="handleClick()">正式发布</el-button>

        <el-button type="default" plain v-if="showInnerG && this.checkInternalTest()" class="testBtn-test" style="
            width: 104px;
            height: 34px;
            background: #0bcb90;
            border-radius: 4px !important;
            color: #ffffff;
          " @click="innerPub()">内测发布</el-button>
        <el-button type="default" :disabled="true" plain v-if="showInner && this.checkInternalTest()"
          class="testBtn-test" style="
            width: 104px;
            height: 34px;
            background: #dfe0e2;
            border-radius: 4px !important;
            color: #ffffff;
          ">内测发布</el-button>

        <!-- 下架 -->
        <el-button type="default" plain v-if="showDown && this.checkDown()" class="return" style="
            background-color: #fff;

            border: 1px solid #1c69d4;
          " @click.native="down(getDatas.courseId)">下架</el-button>
        <!-- 编辑 -->
        <el-button @click="editCourse" v-if="showEdit && this.checkEdit()" type="primary" class="do"
          style="background-color: #256dcd">编辑</el-button>
        <el-button @click="editCourseT" v-if="showEditAgo && this.checkEdit()" type="primary" class="do"
          style="background-color: #256dcd">编辑</el-button>
        <div class="right-btn-float">
          <el-button type="default" plain v-if="showDelete && this.checkDelete()" class="return"
            style="background: #ffffff; border: 1px solid #dfe0e2" @click="handleClickDelete()">删除</el-button>
          <el-button type="default" plain class="return" style="background: #ffffff; border: 1px solid #dfe0e2"
            @click="handleClick()">返回</el-button>
        </div>
      </div>
    </div>
    <br />
    <!--  -->
    <div class="course">
      <div class="courseFirst">
        <div>课程编号</div>
        <div>{{ getDatas.courseDetailVO.courseVO.courseCode }}</div>
      </div>

      <div class="verDivider"></div>
      <div class="courseSecond">
        <div class="secondBox">
          <div>创建人：</div>
          <div>
            <el-tooltip :content="getDatas.creatByUser.realName + '(' + getDatas.courseDetailVO.courseVO.creatBy + ')'"
              placement="bottom" effect="light">
              <div class="ifo-text-contents">
                <div class="hides"> {{ getDatas.creatByUser.realName }}({{
                    getDatas.courseDetailVO.courseVO.creatBy
                }})</div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="secondBox">
          <div>创建时间：</div>
          <div>
            {{ formatDate(getDatas.courseDetailVO.courseVO.creatDate) }}
          </div>
        </div>
        <div class="secondBox">
          <div>修改人：</div>
          <div>
            <el-tooltip :content="getDatas.chngByUser.realName + '(' + getDatas.courseDetailVO.courseVO.chngBy + ')'"
              placement="bottom" effect="light">
              <div class="ifo-text-contents">
                <div class="hides"> {{ getDatas.chngByUser.realName }}({{
                    getDatas.courseDetailVO.courseVO.chngBy
                }})</div>
              </div>
            </el-tooltip>

          </div>
        </div>
        <div class="secondBox">
          <div>修改时间：</div>
          <!-- todo修改 -->
          <div>{{ formatDate(getDatas.courseDetailVO.courseVO.chngDate) }}</div>
        </div>
      </div>
      <div class="verDivider"> </div>

      <div class="courseThird">
        <div>课程状态</div>
        <div class="third">
          <div style="display: flex; width: 52px; height: 10px; margin-top: -2px">
            <div style="
                background-color: rgba(0, 180, 42, 1);
                border-radius: 50%;
                width: 6px;
                height: 6px;
                margin-top: 7px;
              " :style="{
                'background-color':
                  stateArr[getDatas.courseDetailVO.courseStatus].color,
              }"></div>
            <div class="text_273">
              {{ stateArr[getDatas.courseDetailVO.courseStatus].name }}
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 基本信息start -->
    <div class="ifo">
      <br />
      <div class="ifoFirst">
        <div class="line"></div>
        <span class="bmw-text">基本信息
          <el-tooltip content="新建必须填写品牌和业务团队" placement="bottom" effect="light">
            <img style="margin: -3px 0px 0px 4px;" src="@/assets/img/course/icon-question-fill.png" alt="" />
          </el-tooltip>
        </span>
      </div>
      <!-- 隔离线 -->
      <div class="block_42 flex-col"></div>

      <!-- 基本信息整体布局 -->
      <div class="ifo-all-three">
        <!-- 基本信息头部布局start -->
        <div class="ifo-top">
          <div class="ifo-text">品牌</div>
          <div class="ifo-text-content">
            {{ getDatas.courseDetailVO.courseVO.brandName }}
          </div>
        </div>
        <!-- 基本信息头部布局end -->
        <!-- 隔离线虚线 -->
        <div class="box_23 flex-col"></div>

        <div class="ifo-middle">
          <!-- class="ifo-middle-first" -->


          <el-row class="el-rowStyle">
            <el-col :span="6">
              <div class="one">
                <div class="ifo-text">
                  业务团队<span>
                    <el-tooltip content="请选择该课程所归属的业务团队。" placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ getDatas.courseDetailVO.courseVO.teamTypeDesc }}_{{
                      getDatas.courseDetailVO.courseVO.teamTypeChildDesc
                  }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="two">
                <div class="ifo-text">课程中文名称</div>
                <el-tooltip :content="getDatas.courseDetailVO.courseVO.courseName" placement="bottom" effect="light">
                  <div class="ifo-text-content">
                    <div class="hide"> {{ getDatas.courseDetailVO.courseVO.courseName }}</div>
                  </div>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">课程英文名称</div>
                <el-tooltip :content="getDatas.courseDetailVO.courseVO.courseNameEn" placement="bottom" effect="light">
                  <div class="ifo-text-content">
                    <div class="hide"> {{ getDatas.courseDetailVO.courseVO.courseNameEn }}</div>
                  </div>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="four">
                <div class="ifo-text">
                  课程分类
                  <span>
                    <el-tooltip content="请选择该课程所归属的业务团队。" placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ getDatas.courseDetailVO.courseVO.classifyName }}
                </div>
              </div>
            </el-col>
          </el-row>


          <el-row class="el-rowStyle">
            <el-col :span="6">
              <div class="one">
                <div class="ifo-text">
                  KTC Code
                  <span>
                    <el-tooltip content="AG关联课程代码，若无对应KTC，请填写#NO-KTC； 需要填写多个KTC时，请用英文逗号隔开。" placement="bottom"
                      effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>

                <el-tooltip :content="getDatas.courseDetailVO.courseVO.ktcCode" placement="bottom" effect="light">
                  <div class="ifo-text-content">
                    <div class="hide"> {{ getDatas.courseDetailVO.courseVO.ktcCode }}</div>
                  </div>
                </el-tooltip>


                <!-- <div class="ifo-text-content">
                {{ getDatas.courseDetailVO.courseVO.ktcCode }}
              </div> -->
              </div>
            </el-col>
            <el-col :span="6">
              <div class="two">
                <div class="ifo-text">关键字</div>
                <el-tooltip :content="getDatas.courseDetailVO.courseVO.keyword" placement="bottom" effect="light">
                  <div class="ifo-text-content">
                    <div class="hide"> {{ getDatas.courseDetailVO.courseVO.keyword }}</div>
                  </div>
                </el-tooltip>

              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">
                  是否限制学习
                  <span>
                    <el-tooltip content="如选择限制，则面向组群外的用户将无法在app中查找到本课程进行学习。" placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.isLimit) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="four">
                <div class="ifo-text">
                  结课证明设置
                  <span>
                    <el-tooltip content="如选择“是”，则系统将在用户完成本课程学习后，自动颁发结课证明恭贺用户。结课证明只代表用户完成了课程的学习，不代表获得了相应的资质证书。"
                      placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{
                      getFlagHasCertificateFlag(
                        getDatas.courseDetailVO.courseVO.hasCertificateFlag
                      )
                  }}
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row class="el-rowStyle">
            <el-col :span="6">
              <div class="one">
                <div class="ifo-text">
                  是否为AI课程
                  <span>
                    <el-tooltip content="如选择“是”，则系统将在用户完成本课程学习后，自动颁发结课证明恭贺用户。结课证明只代表用户完成了课程的学习，不代表获得了相应的资质证书。"
                      placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.aiFlag) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">
                  AI考试课程
                  <span>
                    <el-tooltip content="如选择“是”，则系统将在用户完成本课程学习后，自动颁发结课证明恭贺用户。结课证明只代表用户完成了课程的学习，不代表获得了相应的资质证书。"
                      placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.aiExamFlag) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="two">
                <div class="ifo-text">AI课程标签</div>


                <el-tooltip :content="getDatas.courseDetailVO.courseVO.aiTag" placement="bottom" effect="light">
                  <div class="ifo-text-content">
                    <div class="hide"> {{ getDatas.courseDetailVO.courseVO.aiTag }}</div>
                  </div>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="four">
                <div class="ifo-text">
                  课程标准时长
                  <span>
                    <el-tooltip content="由开发老师预估，表示用户完成课程需要投入的时间，一天按6小时计算。" placement="bottom" effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;"
                        src="@/assets/img/course/icon-question-fill.png" alt="" />
                    </el-tooltip>
                  </span>
                </div>
                <div class="ifo-text-content">
                  {{ numFilter(getDatas.courseDetailVO.courseVO.duration) }}/天
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="el-rowStyle">
            <el-col :span="6">
              <div class="one">
                <div class="ifo-text">
                  是否开启练习报告
                  <!-- <span>
                    <el-tooltip content="如选择“是”，则系统将在用户完成本课程学习后，自动颁发结课证明恭贺用户。结课证明只代表用户完成了课程的学习，不代表获得了相应的资质证书。" placement="bottom"
                      effect="light">
                      <img style="margin: -3px 0px 0px 4px;cursor: pointer;" src="@/assets/img/course/icon-question-fill.png"
                        alt="" />
                    </el-tooltip>
                  </span> -->
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.isExerciseRep) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">
                  是否开启考试报告
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.isExamRep) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">
                  是否根据通关分数显示练习详情
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.showExerciseInfo) }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="three">
                <div class="ifo-text">
                  是否根据通关分数显示考试详情
                </div>
                <div class="ifo-text-content">
                  {{ getFlag(getDatas.courseDetailVO.courseVO.showExamInfo) }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 隔离线 -->
        <div class="box_23 flex-col"></div>

        <div class="ifo-bottom">
          <div class="ifo-bottom-title">
            <div style="margin-bottom: 21px">面向组群</div>

            <div class="rightIfoContent rightIfoContent2">
              <div :style="{ 'max-height': 160 + 'px' }" style="
                  overflow-y: scroll;
                  overflow-x: hidden;
                  background: 249, 250, 250;
                ">
                <div v-for="(item, index) in listone" :key="index" style="display: inline-block">
                  <el-tag>{{ item.bizDesc }}</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="ifo-bottom-title">
            <div style="margin-bottom: 21px">负责培训师</div>

            <div class="rightIfoContent">
              <div :style="{ 'max-height': 160 + 'px' }" style="
                  overflow-y: scroll;
                  overflow-x: hidden;
                  background: 249, 250, 250;
                ">
                <div class="for-second" v-for="(item, index) in listsecond" :key="index" style="display: inline-block">
                  <el-tag>{{ item.instructorName }}({{ item.trainnerUserName }})</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="ifo-bottom-title">
            <div style="margin-bottom: 21px">内测人员</div>

            <div class="rightIfoContent">
              <div :style="{ 'max-height': 160 + 'px' }" style="
                  overflow-y: scroll;
                  overflow-x: hidden;
                  background: 249, 250, 250;
                ">
                <div class="for-third" v-for="(item, index) in listThird" :key="index" style="display: inline-block">
                  <el-tag>{{ item.bizDesc }}</el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 基本信息end -->
    <!-- 课程介绍开始 -->
    <div class="courseIfo">
      <br />
      <div class="courseIfoFirst">
        <div class="line"></div>
        <span class="bmw-text">课程介绍</span>
        <span>
          <el-tooltip content="模块1和模块2的名字可自定义，例如课程目标，课程亮点。模块2为非必填项。每个模块下的内容支持文字和图片混合排版，请根据需求自由添加文本、图片、视频。"
            placement="bottom" effect="light">
            <img style="margin: -3px 0px 0px 4px;cursor: pointer;" src="@/assets/img/course/icon-question-fill.png"
              alt="" />
          </el-tooltip>
        </span>
      </div>
      <!-- 隔离线虚线 -->
      <div class="box_23 flex-col"></div>
      <div class="courseIfo-moudle">
        <!-- 头部按钮 -->
        <div class="courseIfo-moudle-header">
          <div v-show="btnO" class="moudleone-btn" @click="moduleoneMethod()">模块一</div>
          <div v-show="!btnO" class="moudleoneT-btn" @click="moduleoneMethod()">模块一</div>
          <div v-show="btnT" class="moudletwo-btn" @click="moduleTwoMethod()">模块二</div>
          <div v-show="!btnT" class="moudletwoT-btn" @click="moduleTwoMethod()">模块二</div>
        </div>
        <!-- 内容 -->
        <div class="courseIfo-moudle-content">

          <div v-show="moudleOneShow">
            <courseTitle :Title.sync="Title" :Text.sync="Text" :Picture.sync="Picture" :Video.sync="Video"
              :moduleIntro.sync="moduleOneIntro"></courseTitle>
          </div>


          <div v-show="!moudleOneShow">
            <courseTitle :Title.sync="TitleT" :Text.sync="TextT" :Picture.sync="PictureT" :Video.sync="VideoT"
              :moduleIntro.sync="moduleTwoIntro"></courseTitle>
          </div>




        </div>
      </div>


    </div>

    <!-- 课程介绍结束 -->

    <div class="listImg">
      <br />
      <div class="courseIfoFirst">
        <div class="line"></div>
        <span class="bmw-text">上传图片</span>
      </div>
      <!-- 隔离线虚线 -->
      <div class="box_23 flex-col"></div>
      <div class="pic">
        <div class="content">
          <div class="title">列表图片</div>
          <div class="ifoImg2">
            <img :src="picURL" alt="" style=" width: 200px;
height: 100px;
border-radius: 4px;" />
          </div>
        </div>
        <div class="pic-part">
          <img class="picStyle" src="@/assets/img/newnesscourse/leftpart.png" alt="" />
        </div>
      </div>



    </div>
    <div class="setting">
      <br />
      <div class="courseIfoFirst">
        <div class="line"></div>
        <span class="bmw-text">章节设置</span>
        <span>
          <el-tooltip content="微课中包含的章的设置，章中包含的小节的设置。" placement="bottom" effect="light">
            <img style="margin: -3px 0px 0px 4px;cursor: pointer;" src="@/assets/img/course/icon-question-fill.png"
              alt="" />
          </el-tooltip>
        </span>
      </div>
      <div class="block_42 flex-col"></div>
      <!-- 是否要求顺序学习 -->
      <span class="name">
        <span style="display:inline;margin-left: 20px;font-size: 14px;" class="bmw-text">是否要求顺序学习</span>
        <el-tooltip content="按顺序学习规则中不包含对选修课的约束。" placement="bottom" effect="light">
          <img style="margin: -3px 0px 0px 4px" src="@/assets/img/course/icon-question-fill.png" alt="" />
        </el-tooltip>
      </span>
      <el-select disabled style="width: 5rem !important;margin-left: 10px;margin-top: 10px"
        v-model="getDatas.courseDetailVO.courseVO.isOrderStudy">
        <el-option v-for="item in isOrderStudyList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div class="settingContent">
        <div :style="{ 'max-height': this.timeLineHeight + 'px' }" style="overflow-y: scroll; overflow-x: hidden;width: 35%;">
          <div class="settingLeft">
            <div v-for="(item, index) in listChapters" :key="index">
              <el-tooltip :content="item.chapterName" placement="bottom" effect="light">
                <div class="settingWord" @click="setListChaptersIndex(index)">
                  <div class="contenthide">
                    <span style="padding-left: 8px;">{{ item.sequence }}</span>

                    <span style="margin-left:8px;cursor: pointer">
                      {{ item.chapterName }}</span>

                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="settingRight" :style="{ 'max-height': this.timeLineHeight + 'px' }"
          style="overflow-y: scroll; overflow-x: hidden">
          <!-- {{listChapters[listChaptersIndex].subList}} -->
          <template v-if="listChapters && listChapters.length">
            <div v-for="(item, index) in listChapters[listChaptersIndex].subList" :key="index">
              <div class="settingRightContent">
                <div class="settingRightContentone">0{{ item.sequence }}</div>
                <div class="settingRightContentImg" style="">
                  <div style="width: 100%; height: 100%">
                    <img src="@/assets/img/course/pic@2x.png" alt=""
                      v-if="getTypeItem(item.chapterType).typeNum == 7" />
                    <img src="@/assets/img/course/ai@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 80" />
                    <img src="@/assets/img/course/zip@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 60" />
                    <img src="@/assets/img/course/vr@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 70" />
                    <img src="@/assets/img/course/wbt@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 50" />
                    <img src="@/assets/img/course/pdf@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 1" />
                    <img src="@/assets/img/course/video@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 2" />
                    <img src="@/assets/img/course/h5@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 4" />
                    <img src="@/assets/img/course/exame@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 5" />
                    <img src="@/assets/img/course/homework@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 6" />
                    <img src="@/assets/img/course/h5out@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 8" />
                    <img src="@/assets/img/course/music@2x.png" alt=""
                      v-else-if="getTypeItem(item.chapterType).typeNum == 9" />
                  </div>
                </div>

                <div class="settingRightContentones" style="display: flex">
                  <span>类型:</span>
                  <div class="settingRightContentTwo">
                    <div @click="clickResource(item)" class="settingRightContentThree">
                      {{ getTypeItem(item.chapterType).name }}
                    </div>
                  </div>
                </div>
                <div class="settingRightContentFour">
                  <div style="display: flex">
                    <div class="tag-style">
                      <span>标签:</span>
                    </div>

                    <span style="margin-left: 6px">{{
                        getoptionalStudyType(item.optionalStudyType)
                    }}</span>
                    <span style="margin-left: 6px">{{
                        getoptional(item.optional)
                    }}</span>
                  </div>
                </div>
                <div class="contenthide">
                  <span style="margin-left: 20px">名称:</span>
                  <el-tooltip :content="item.subChapterName" placement="bottom" effect="light">
                    <span style="margin-left: 2px;cursor: pointer">
                      {{ item.subChapterName }}</span>
                  </el-tooltip>
                </div>
                <div class="contenthide">
                  <span style="margin-left: 20px">位置:</span>
                  <el-tooltip :content="item.subChapterPath" placement="bottom" effect="light">
                    <span style="margin-left: 6px;cursor: pointer">
                      {{ item.subChapterPath }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="intro">
      <br />
      <div class="courseIfoFirst">
        <div class="line"></div>
        <span class="bmw-text">推荐课程</span>
      </div>
      <!-- 隔离线虚线 -->
      <div class="box_23 flex-col"></div>

      <!-- <img :src="item.coursePageVO.listUrl" alt=""> -->
      <div class="courseRecommendListStyle">
        <div v-for="(item, index) in courseRecommendList" :key="index" style="width:30%">
        <div class="introContent">
          <div class="introImg" :style="{
            'background-image': 'url(' + item.coursePageVO.listUrl + ')',
          }"></div>
          <div>
            <el-tag class="typeGold">
              <div class="typeSt">
                {{ item.coursePageVO.classifyTopName }}
              </div>
            </el-tag>
          </div>
          <div style="margin-top: 5px">

            <el-tooltip
                    :content="item.coursePageVO.courseName"
                    placement="bottom"
                    effect="light"
                  > <div class="ifo-text-content">
              <div class="hideCourseName">  {{ item.coursePageVO.courseName }}</div>
              </div></el-tooltip>

          </div>
          <div class="introShuxing">
            <div>
              <span>发布时间</span><span>{{ formatDate(item.coursePageVO.pubDate) }}</span>
            </div>
            <div>
              <span style="margin-top: 14px">负责培训师</span><span style="margin-top: 14px" class="contenthides">
                <el-tooltip :content="item.coursePageVO.trainerName" placement="bottom" effect="light">
                  <span>{{ item.coursePageVO.trainerName }}</span>
                </el-tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>

    </div>


    <!-- 下架弹窗 -->
    <el-dialog :visible.sync="dialogVisible2" width="25%" custom-class="dropdown-dialog">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">下架提示</div>
      </div>
      <div class="tip">
        下架了该课程，学员将无法在APP端学习，请您确认是否下架？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false" class="dialog-footer-btn-n">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="downId" class="dialog-footer-btn-y">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 正式发布弹窗 -->
    <el-dialog :visible.sync="showInnerDialog" custom-class="showInnerDia">
      <div class="teamtopstyle">
        <div class="line"></div>
        <div slot="title" class="teamtitle" style="margin-top: 3px">
          发布提示
        </div>
      </div>

      <div class="resourcelines" style="
          width: 100% !important;
          height: 1px;
          background: rgba(0, 0, 0, 0.1) !important;
          margin: 0px 0px 19px !important;
        "></div>
      <div class="contentHeader">
        <div class="title">请确认是否需要通知用户,课程发布的信息？</div>
        <el-radio-group v-model="radioY" @change="messagePubChange" class="message-father">
          <el-radio :label="1" class="message-y">通知，用户会在"消息通知"/"最新更新"看到课程发布的信息</el-radio>
          <el-radio :label="0" class="message-n">不通知，用户不会在"消息通知"/"最新更新"看到课程发布的信息</el-radio>
        </el-radio-group>
        <div class="title-text-area">消息通知内容</div>
        <div class="content-content-main">
          <el-input :disabled="this.radioY == 0" type="textarea" v-model="messagePub" maxlength="100" show-word-limit
            rows="6" placeholder="可简述课程更新的内容，以“消息通知”的形式通知用户例：
本课程更新如下：
1.新增了iX产品介绍视频；
2.增加巩固对本课程知识点的课后作业；
请认真学习本课程，完成后续的行动计划等相关作业。">
          </el-input>
        </div>
        <div class="btn-textPub">
          <el-button type="default" @click="showInnerDialog = false">取消</el-button>
          <el-button type="primary" @click="pushPub">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="question">
      <br />
      <div class="courseIfoFirst">
        <div class="line"></div>
        <span class="bmw-text">常见问题</span>
        <span>
          <el-tooltip content="请更新本课程的常见问题，方便用户提问前知悉。" placement="bottom" effect="light">
            <img style="margin: -3px 0px 0px 4px;cursor: pointer;" src="@/assets/img/course/icon-question-fill.png"
              alt="" />
          </el-tooltip>
        </span>
      </div>
      <div class="block_42 flex-col"></div>
      <div class="questionContent">
        <el-table :data="tableData" :style="{ 'max-height': 400 + 'px' }"
          style="overflow-y: scroll; overflow-x: hidden; width: 100%">
          <el-table-column type="index" label="序号" min-width="15%">
          </el-table-column>
          <el-table-column prop="questionDesc" label="问题" min-width="30%">
            <template slot-scope="scope">
              <div class="ask-class">
                <div class="ask-content">
                  {{ scope.row.questionDesc }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="answerDesc" label="答案" min-width="40%">
            <template slot-scope="scope">
              <div class="question-class">
                <div class="question-content">
                  {{ scope.row.answerDesc }}
                </div>

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="answerDesc" label="" min-width="15%" align="center">
            <template>

              <img src="@/assets/img/course/delete_block.png" alt="" />

            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="question">
      <br />
      <div class="courseIfoFirst">
        <span class="line"></span>
        <span class="bmw-text">关联课程</span>
        <span>
          <el-tooltip content="点击右侧查询按钮，可查看关联了该微课的慕课、混合式学习课程和任务。" placement="bottom" effect="light">
            <img style="margin: -3px 0px 0px 4px;cursor: pointer;" src="@/assets/img/course/icon-question-fill.png"
              alt="" />
          </el-tooltip>
        </span>

        <el-button type="primary" class="questionButton" size="mini" @click="getRelationLesson()">获取关联课程</el-button>
      </div>
      <div class="block_42 flex-col" style="margin: 15px 0 20px 24px"></div>
      <div class="questionContent" :style="{ 'max-height': this.timeLineHeight + 'px' }"
        style="overflow-y: scroll; overflow-x: hidden">
        <el-table v-loading="isGetRelationLesson" :data="relationLesson" style="width: 100%">
          <el-table-column type="index" label="序号" min-width="150">
          </el-table-column>
          <el-table-column label="类型" min-width="150">
            <template slot-scope="scope">
              <span>{{ getType(scope.row.type) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="课程名称" min-width="150">
          </el-table-column>
          <el-table-column prop="classifyName" label="分类" min-width="150">
          </el-table-column>
          <el-table-column prop="createName" label="创建人" min-width="150">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <span style="
                    border-radius: 50%;
                    width: 6px;
                    height: 6px;
                    margin-top: 0px;
                    background-color: red;
                  " :style="{
                    'background-color': stateArr[scope.row.status].color,
                  }"></span>
                &nbsp;
                <span>{{ stateArr[scope.row.status].name }}</span>
              </div>
            </template>
          </el-table-column>moment
        </el-table>
      </div>
    </div>
    <!-- 内测发布弹窗 -->
    <MyToast :show-toast="toast1" :show-type="0"></MyToast>
    <!-- 正式发布弹窗 -->
    <MyToast :show-toast="toast2" :show-type="1"></MyToast>
    <!-- 删除提示 -->





    <el-dialog :visible.sync="dialogVisibleDel" custom-class="delete-dialog">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">删除提示</div>
      </div>
      <div class="tip">你确定要删除么？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDel = false" class="dialog-footer-btn-n">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="delID" class="dialog-footer-btn-y">确 定</el-button>
      </span>
    </el-dialog>
    <deletePop @refresh="refresh" v-model="dialogVisibleReurn" :dialogVisibleReurn.sync="dialogVisibleReurn">
    </deletePop>
  </div>
</template>

<script>
import view from '../../charge/handworkBalanceAccount/view.vue'
import moment from 'moment'
import deletePop from '@/components/course/Delete.vue'
import MyToast from '@/components/course/MyToast.vue'
import courseTitle from '@/components/course/courseTitle.vue'
import themeViewVue from '../../grow/theme/themeView.vue'
// import { log } from "fullcalendar/src/util";
export default {
  data() {
    return {
      isGetRelationLesson: false,
      isOrderStudyList: [
        {
          value: "10",
          label: "是",
        },
        {
          value: "20",
          label: "否",
        },
      ],
      dialogVisibleReurn: false,
      btnO: true,
      btnT: true,
      moudleOneShow: true,
      moduleTwoShow: false,
      // 内测弹窗
      dialogVisibleDel: false,
      Video: [],
      Title: "",
      TitleT: "",
      Text: [],
      Picture: [],
      VideoT: [],
      TextT: [],
      PictureT: [],
      toast1: false,
      // 正式发布弹窗
      toast2: false,

      messagePub: '',
      radioY: 1,
      showInnerDialog: false,
      isReloadData: true,
      showPubG: true,
      showDown: true,
      showEdit: true,
      showEditAgo: false,
      showInnerG: true,
      showInner: true,
      showPub: true,
      showDelete: true,
      showTestBtn: true,
      dialogVisible2: false,
      photoShow: false,
      downInfo: {},
      relationLesson: [],
      chapterTypeArr: [
        {
          typeNum: 7,
          name: '图片',
        },
        {
          typeNum: 80,
          name: 'AI',
        },
        {
          typeNum: 1,
          name: 'PDF',
        },
        {
          typeNum: 2,
          name: '视频',
        },
        {
          typeNum: 4,
          name: 'H5',
        },
        {
          typeNum: 5,
          name: '考试',
        },
        {
          typeNum: 6,
          name: '作业',
        },
        {
          typeNum: 8,
          name: '外部H5链接',
        },
        {
          typeNum: 9,
          name: '音频',
        },
        {
          typeNum: 60,
          name: 'ZIP',
        },
        {
          typeNum: 70,
          name: 'VR',
        },
        {
          typeNum: 50,
          name: 'WBT',
        },
      ],
      stateArr: [
        {
          name: '未发布',
          color: 'rgba(255, 168, 0, 1)',
        },
        // 内测发布的状态
        {
          name: '未发布',
          color: 'rgba(255, 168, 0, 1)',
        },
        {
          name: '已发布',
          color: 'rgba(0, 180, 42, 1)',
        },
        {
          name: '已下架',
          color: 'rgba(255, 65, 65, 1)',
        },
      ],
      typeArr: [],
      picURL: '',
      listULS: '',
      listone: [{}],
      listsecond: [{}],
      listThird: [{}],
      listChapters: [
        {
          subList: {
            sequence: '',
          },
        },
      ],
      courseRecommendList: [
        {
          coursePageVO: {
            listUrl: '',
          },
        },
      ],
      getDatas: {
        courseDetailVO: {
          courseVO: {
            aiExamFlag: '',
            aiFlag: '',
          },
          ctList: [],
        },
      },
      courseId: '',
      courseData: {
        brandId: '',
        brandName: '',
        chapterNum: '',
        classifyTopId: '',
        classifyTopName: '',
        courseCode: '',
        courseId: '',
        courseName: '',
        courseNameEn: '',
        courseStatus: '',
        creatBy: '',
        creatDate: '',
        duration: '',
        insideObject: '',
        listUrl: '',
        moduleOne: '',
        moduleOneIntro: [],
        moduleTwo: '',
        pubDate: '',
        pubObject: '',
        teamType: '',
        teamTypeDesc: '',
        trainerName: '',
      },
      moduleOneIntro: [],
      moduleTwoIntro: [],
      timeLineHeight: '',
      tableData: [],
      listChaptersIndex: 0,
    }
  },
  components: {
    MyToast,
    courseTitle,
    deletePop
  },
  methods: {
    async clickResource(item) {
      switch (item.chapterType) {
        case 1:
        case 2:
        case 4:
        case 7: {
          const resourceId = item.content;
          if (resourceId) {
            try {
              const res = await this.$request.post(`/course/getResourceUrl?resourceId=${resourceId}`, {});
              window.open(res);
            } catch (err) {
              console.error(err);
            }
          }
          break;
        }
        default: {
          console.log("Unsupported");
        }
      }
},

    // 下架课程
    refresh(data) {
      if (data) {
        this.$request
          .post(
            `/course/updateCourseStatus?courseId=${this.courseId
            }&newStatus=${3}&check=0`,
            {}
          )
          .then((res) => {
            console.log("================下架" + res);
            console.log("================下架" + res.code);
            if (res.code === 1) {
              this.dialogVisibleReurn = false;
              this.getData();
            }
          });
      }
    },

    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(3)
      return realVal
    },
    messagePubChange() {
      if (this.radioY == 0) {
        this.messagePub = ""
      }
    },
    // 编辑按钮权限
    checkEdit() {
      if (this.$hasPermission('joy:learning:newcourse:editcourse')) {
        return true
      }
      return false
    },


    // 下架按钮权限
    checkDown() {
      if (this.$hasPermission('joy:learning:newcourse:undercarriage')) {
        return true
      }
      return false
    },
    // 删除按钮权限
    checkDelete() {
      if (this.$hasPermission('joy:learning:newcourse:delete')) {
        return true
      }
      return false
    },

    // 正式发布按钮权限
    checkPublicTest() {
      if (this.$hasPermission('joy:learning:newcourse:publictest')) {
        return true
      }
      return false
    },
    // 内测发布按钮权限
    checkInternalTest() {
      if (this.$hasPermission('joy:learning:newcourse:Internaltest')) {
        return true;
      }
      return false;
    },
    // 模块按钮
    moduleoneMethod() {
      this.moudleOneShow = true;
      this.moudleTwoShow = false;
      this.btnO = true;
      this.btnT = true;
    },
    moduleTwoMethod() {
      this.moudleTwoShow = true;
      this.moudleOneShow = false;
      this.btnO = false;
      this.btnT = false;
    },






    handleClickDelete() {
      this.dialogVisibleDel = true
    },
    delID() {
      this.$request
        .post(
          `/course/updateCourseStatus?courseId=${this.courseId}&newStatus=${7}`,
          {}
        )
        .then((res) => {
          this.$router.push({
            path: '/select',
          })
          this.$message.success('删除成功')
        })
      this.dialogVisibleDel = false
      this.getData()
    },

    editCourse() {
      console.log('传值开始')
      const saveId = this.courseId
      let tabName = this.$store.state.contentTabsActiveName
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }
      this.$router.push({
        path: '/saveCourse',
        query: { saveId: saveId },
      })
      setTimeout(function () { }, 100)
      this.$eventHub.$emit('saveId', saveId)
    },
    editCourseT() {
      console.log('传值开始')
      const saveId = this.courseId
      let tabName = this.$store.state.contentTabsActiveName
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }
      this.$router.push({
        path: '/pubCourse',
        query: { saveId: saveId },
      })
      setTimeout(function () { }, 100)
      this.$eventHub.$emit('saveId', saveId)
    },
    innerPub() {
      this.$request
        .post(
          `/course/updateCourseStatus?courseId=${this.courseId
          }&newStatus=${1}&isNotify=${1}`,
          {}
        )
        .then((res) => {
          this.getData()
          this.openSuccess()
        })
    },

    openSuccess() {
      // this.$message({
      //   message: "恭喜你，内测发布",
      //   description: "文字说明文字说明文字说明文字说明文字说明文字说明",
      //   type: "success",
      // });
      // 内测发布自定义弹窗
      console.log('你好')
      this.toast1 = true
      setTimeout(() => {
        this.toast1 = false
      }, 1500)
    },
    pushPub() {
      if (this.radioY == 0) {
        this.messagePub = "";

      }
      if(this.radioY==1&&this.messagePub==""){
        this.$message.warning('请输入消息通知内容')
        return
      }


      this.$request
        .post(
          `/course/updateCourseStatus?courseId=${this.courseId
          }&newStatus=${2}&isNotify=${this.radioY}&notifyContent=${this.messagePub}`,
          {}
        )
        .then((res) => {
          this.showInnerDialog = false
          this.toast2 = true


          setTimeout(() => {
            this.toast2 = false


            let tabName = this.$store.state.contentTabsActiveName
            this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
              (item) => item.name !== tabName
            )
            if (tabName === this.$store.state.contentTabsActiveName) {
              this.$router.push({
                name: this.$store.state.contentTabs[
                  this.$store.state.contentTabs.length - 1
                ].name,
              })
            }
            this.$router.push({
              path: '/manage/learning-course-CourseListSelect',
            })
          }, 1500)
        })
    },
    pubG() {
      this.showInnerDialog = true
      // 正式发布自定义弹窗
    },
    reloadPart() {
      this.isReloadData = false
      this.$nextTick(() => {
        this.isReloadData = true
      })
    },
    getStatus() {
      if (this.getDatas.courseDetailVO.courseStatus == 3) {
        this.showPubG = false
        this.showPub = false
        this.showInnerG = false
        this.showInner = false
        this.showDown = false
        this.showEdit = true
        this.showEditAgo = false
        this.showDelete = false
      } else if (this.getDatas.courseDetailVO.courseStatus == 0) {
        this.showPub = true
        this.showInnerG = true
        this.showEdit = true
        this.showDelete = true
        this.showPubG = false
        this.showEditAgo = false
        this.showInner = false
        this.showDown = false
      } else if (this.getDatas.courseDetailVO.courseStatus == 2) {
        this.showPubG = false
        this.showPub = false
        this.showInnerG = false
        this.showInner = false
        this.showDown = true
        this.showEdit = false
        this.showEditAgo = true
        this.showDelete = false
      } else if (this.getDatas.courseDetailVO.courseStatus == 1) {
        this.showPubG = true
        this.showPub = false
        this.showInnerG = false
        this.showInner = true
        this.showDown = false
        this.showEdit = true
        this.showEditAgo = false
        this.showDelete = true
      }

      console.log(this.courseData.courseStatus, '状态')
      // location.reload();

      console.log('进来了')
    },
    handleClick() {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = 'home'
        return false
      } // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }
    },

    down(data) {
      this.downInfo = data
      this.dialogVisible2 = true
    },
    downId() {
      this.$request
        .post(`/course/relation/list?courseId=${this.courseId}`, {})
        .then((res) => {
          console.log(res,"关联课程数据=========")
          if (res.length>0) {
            console.log("关联课程数据进来了========")
            this.dialogVisibleReurn = true
            this.dialogVisible2 = false
          } else {
            this.$request
              .post(
                `/course/updateCourseStatus?courseId=${this.courseId
                }&newStatus=${3}&check=1`,
                {}
              )
              .then((res) => {
                console.log("================下架" + res);
                console.log("================下架" + res.code);
                if (res.code === 1) {
                  this.dialogVisible2 = false;
                  this.getData();
                }
              });
          }
        })
    },
    getTypeItem(typeNum) {
      let chapterType = this.chapterTypeArr.find((item) => {
        return item.typeNum == typeNum
      })
      if (chapterType) {
        return chapterType
      } else {
        return {
          name: '',
          src: '',
        }
      }
    },
    setListChaptersIndex(index) {
      this.listChaptersIndex = index
    },
    // dataset(){
    //  this.listsecond=this.getDatas.courseDetailVO.ctList
    //  console.log(this.listsecond)
    // },
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(date).format(format)
    },
    getRelationLesson() {
      this.isGetRelationLesson = true
      this.$request
        .post(`/course/relation/list?courseId=${this.courseId}`, {})
        .then((res) => {
          this.relationLesson = res
          console.log(this.relationLesson)
          console.log(res)
          this.isGetRelationLesson = false
        })
    },
    getModuleOneIntroV(data) {
      if (data) {
        let arr = JSON.parse(data)
        if (arr[0]) {
          return arr[0].value
        }
      }
      return ''
    },
    getoptionalStudyType(data) {
      if (data == 0) {
        return '选修'
      }
      return ''
    },
    getoptional(data) {
      if (data == 0) {
        return '更新'
      }
      return ''
    },
    getFlag(data) {
      if (data === 0) {
        return '否'
      }
      if (data == '' || !data) {
        return '-'
      }
      return '是'
    },
    getType(data) {
      if (data == 1) {
        return 'banner'
      } else if (data == 2) {
        return '任务'
      } else if (data == 3) {
        return '弹窗消息'
      } else if (data == 4) {
        return '最新推荐'
      } else if (data == 5) {
        return '慕课'
      } else if (data == 6) {
        return '混合式学习'
      } else if (data == 7) {
        return '学习路径'
      } else if (data == 8) {
        return '辅导'
      } else if (data == 9) {
        return '微课'
      } else if (data == 10) {
        return '活动'
      } else if (data == 11) {
        return '资料'
      }
    },

    deactivated() {
      let list = document.getElementsByClassName("el-tooltip__popper");
      console.log("🚀 ~ file: index.vue ~ line 309 ~ deactivated ~ list", list)
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
    },
    getFlagHasCertificateFlag(data) {
      if (data === 10) {
        return '是'
      }
      return '否'
    },
    getModuleOneIntroVt(data) {
      if (data) {
        let arr = JSON.parse(data)
        if (arr[1]) {
          return arr[1].value
        }
      }
      return ''
    },
    getData() {
      this.$request
        .post(`/course/detail?courseId=${this.courseId}`, {
          map: {},
        })
        .then((res) => {
          this.getDatas = res
          console.log(this.getDatas, 'getData获取数据')
          let moduleOneIntro = this.getDatas.courseDetailVO.courseVO.moduleOneIntro
          moduleOneIntro = moduleOneIntro.replace(/\n/g, '/n')
          if (moduleOneIntro) {
            // this.$set(this,'moduleOneIntro',JSON.parse(moduleOneIntro))
            this.moduleOneIntro = JSON.parse(moduleOneIntro)
          }
          if (this.getDatas.courseDetailVO.courseVO.moduleOne) {
            this.Title = this.getDatas.courseDetailVO.courseVO.moduleOne
          }
          if (this.getDatas.courseDetailVO.courseVO.moduleTwo) {
            this.TitleT = this.getDatas.courseDetailVO.courseVO.moduleTwo
          }

          let moduleTwoIntro = this.getDatas.courseDetailVO.courseVO.moduleTwoIntro


          if (moduleTwoIntro) {
            moduleTwoIntro = moduleTwoIntro.replace(/\n/g, '/n')
            this.$set(this, 'moduleTwoIntro', JSON.parse(moduleTwoIntro))
          }
          this.picURL = res.courseDetailVO.coursePicVO.listPic

          this.listone = res.courseDetailVO.csList

          console.log(this.getDatas)

          this.listsecond = res.courseDetailVO.ctList

          this.listThird = res.courseDetailVO.cstList
          this.tableData = res.courseDetailVO.faqList
          this.courseRecommendList = res.courseDetailVO.courseRecommendList
          this.listChapters = res.courseDetailVO.ccList
          console.log('>>>', this.listChapters)
          this.getStatus()
        })
    },
  },
  watch: {
    '$route'(to, from) {

      if (to) {

        this.getData()
        this.deactivated()
      }

    }
  },
  activated() {
    // window.location.reload();
    // this.$forceUpdate()
  },
  created() {
    this.deactivated()
    // // 强制渲染组件
    // this.$forceUpdate()
    // this.$router.go(0);
    // this.reloadPart();
    this.timeLineHeight = document.documentElement.clientHeight - 210
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight - 210
    }

    this.$eventHub.$on('show', (row) => {
      this.courseId = row.courseId
      this.courseData = row
      console.log(this.courseData, 'this.courseData')
      console.log(row)
      console.log('传过来的id为' + this.courseId)

    })
    console.log('>>>', this.courseId)
    if (!this.courseId) {
      console.log('>>22')
      if (this.$route.query.show) {
        let show = JSON.parse(this.$route.query.show)
        console.log('>>33', show)
        this.courseId = show.courseId
        this.courseData = show
        // this.getStatus();

        // location.reload();


        console.log(this.courseData, 'this.courseData')
      }
    }

    this.$eventHub.$on('saveId', (saveId) => {
      this.courseId = saveId
      console.log(this.courseId, '传过来的值为')

    })
    if (!this.courseId) {
      if (this.$route.query.saveId) {
        let show = JSON.parse(this.$route.query.saveId)

        this.courseId = show

      }
    }
    this.getData()
  },
  mounted() {

    //
  },
}
</script>

<style lang="scss">
.return:focus {
  background: #fff !important;
  color: #256dcd !important;
}

/* 表单头部颜色更改 */
.aui-wrapper .el-table th {
  background: #fafbff !important;
  border-right: 1px #dcdee3 solid
}

.testBtn-test:hover {
  color: #fff !important;
  background: #dfe0e2 !important;
}

.return:hover {
  background: #fff !important;
  color: #256dcd !important;
}

.el-tooltip__popper {
  border: none !important;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}

.popper__arrow {
  border: none !important;
}
</style>
<style lang="scss" scoped>
// bmw字体
.bmw-text {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-size: 16px;
}



.el-tooltip {
  cursor: pointer;
}

.btn-top {
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 16px;
  float: right;
  display: flex;

  .right-btn-float {
    margin-left: -9px;
  }
}

.block_25 {
  width: 338px;
  height: 134px;
  margin: 16px 0 0 54px;
}

.text_5 {
  width: 28px;
  height: 20px;
  color: rgba(153, 154, 156, 1);
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.group_3 {
  width: 294px;
  height: 134px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng73e5739e80853dfd2da99afafc6e08ec7f5ba959fc92ed3e6618cf72dc8c0492) -1px -1px no-repeat;
  background-size: 296px 136px;
}

.index {
  height: 100%;
  //  width: 100vw;
  background-color: #f1f3f8;
  margin: 0px auto;
}

.return {
  color: #256dcd;
  border-color: #256dcd;
  background-color: #fff;
  border-radius: 4px !important;
}

.do {
  background-color: #256dcd;
  border-radius: 4px !important;
}

.doList {
  background-color: #fff;
  width: 100%;
  height: 50px;
  border-radius: 4px;
  padding-top: 10px;
}

.return:nth-child(1) {
  margin-left: 20px;
}

.return:nth-child(2) {
  margin-right: 20px;
}

.course {
  width: 100%;
  height: 80px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.courseFirst {
    width: 24%;
    margin-top: 5px;
    margin-left: 20px;
    padding: 0 0 0 0;
    white-space: nowrap;

}

.verDivider {
  width: 1px;
  height: 59px;
  background-image: linear-gradient(#ccc 35%, rgba(255, 255, 255, 0) 0%);
  background-position: left;
  background-size: 1px 10px;
  background-repeat: repeat-y;
  margin: 7px 0 7px 0;
}

.block_42 {
  width: 97%;
  height: 1px;
  background: #EEEFF0FF -1px 0px no-repeat;
  background-size: 98% 1px;
  margin: 13px 0 12px 24px;
}

.box_23 {
  width: 97%;
  height: 1px;
  margin: 16px 0 0 24px;
  background-image: linear-gradient(to right, #ccc 60%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 10px 1px;
  background-repeat: repeat-x;
}


.course>div {
  float: left;
}

.courseThird {
    padding: 0 0 0 0;
    margin-left: 8px;
    margin-top: 5px;
    padding-left: 2px;
    width: 2%;
    white-space: nowrap;

  .text_273 {
    padding-left: 5px;
  }
}

.doList .el-button:not(:nth-child(1)) {
  float: right;
}

.courseSecond {
  // 弹性铺满
    margin-top: 5px;
    padding: 0 8px 0 8px;
    display: flex;
    column-gap: 6px;
    width: 65%;
    white-space: nowrap;
    .secondBox{
      width: 100%;
    }
}

.course1 {
  width: 100%;
  background: #ffff;
}

.courseSecond1 {
  display: flex;
  padding: 16px 0 0 0;
  column-gap: 4px;

  .one {
    display: flex;
    flex-direction: column;
    row-gap: 3px;

    .title {
      color: #a5a5a7;
    }
  }
}

.courseSecond>div {
  float: left;
  margin-left: 3px;
}

.courseFirst>div:nth-child(1),
.course>div>div>div:nth-child(1),
.courseThird>div:nth-child(1) {
  color: #a5a5a7;
  margin-top: 15px;
  margin-bottom: 5px;
}

.third span:nth-child(2) {
  color: #1dbd43;
}

.ifo {
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 4px;

  .ifo-all-three {
    padding-bottom: 34px;

    .ifo-text {
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #999a9c;
      line-height: 20px;
      white-space: nowrap;
    }

    .ifo-text-content {
      width: 36px;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(90, 92, 96, 1);
      font-size: 14px;
      font-family: BMWTypeNextLatinTT-Regular, sans-serif;
      text-align: left;
      white-space: nowrap;
      line-height: 20px;
      margin-top: 8px;

      .hide {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 188px;
        cursor: pointer
      }
    }

    .ifo-top {
      width: 36px;
      height: 48px;
      margin: 24px 0 0 36px;
    }

    .ifo-middle {
      display: flex;
      flex-direction: column;

      .ifo-middle-first {
        width: 36px;
        height: 48px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        column-gap: 293px;
        align-items: center;
        text-align: center;
        margin: 20px 0px 16px 528px;
      }
    }

    .ifo-bottom {
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 53px;
      margin-left: 31px;
    }

    .ifo-bottom-title {
      width: 29%;
      margin-top: 30px;
    }
  }
}

.leftIfo>div {
  float: left;
}

.shuxing {
  width: 200px;
  height: 400px;
  text-align: right;
}

.ifoDivider {
  height: 1px;
  padding: 0 0 0 0;
}

.line {
  width: 3px;
  height: 14px;
  background: #1c69d4;
  float: left;
  margin-right: 10px;
}

.ifoFirst {
  margin-left: 20px;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
}

.warn {
  color: red;
}

.shuxing>div {
  height: 50px;
}

.content div {
  margin-left: 20px;
  height: 50px;
  margin-right: 50px;
}

.ifoDivider2 {
  height: 680px;
  position: absolute;
}

.rightIfo {
  width: 400px;
  height: 680px;
  float: left;
  margin-left: 50px;
}

.rightIfoContent {
  width: 5%;

  opacity: 0.8;
  height: 168px;
  display: table-cell;
  margin-top: 20px;
  border-radius: 4px;
  border-color: #eff0f1;
  border: 2px solid #eff0f1;
  background: #ffffff;
  padding-top: 10px;
  padding-left: 10px;
}

.el-tag {
  background-color: #e7eef7;
  color: #1c69d4ff;
  margin: 3px;
  border: none;
}

.rightIfoContent2>.el-tag {
  border: 1px none dff2e4;
}

.blue {
  background-color: #e7eef7;
  color: #256fd5;
}

.rightIfo1:not(:nth-child(1)) {
  margin-top: 50px;
}

.courseIfo {
  width: 100%;
  height: 100%;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 4px;
}

.courseIfoFirst {
  margin-left: 20px;
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
}

.courseIfoContent>div {
  /* float: left; */
  margin-top: 20px;
  width: 700px;
  margin-left: 106px;
}

.courseIfoContent>div:nth-child(1) {
  /* width: 200px; */
  width: 100%;
  text-align: left;
  color: #a5a5a7;
  margin-left: 3px;
}

.courseIfoContent>div:nth-child(2) {
  margin-left: 106px;
  width: 700px;
  margin-top: -15px;
}

.secondContent {
  margin-left: 0px !important;
  padding: 0 0 11px 0 !important;
}

.ifoImg {
  width: 200px;
  height: 100px;
  /* background-color: #a5a5a7; */
  border-radius: 20px;
}

.ifoImg>div {
  width: 200px;
  height: 100px;
  /* background-color: #a5a5a7; */
  border-radius: 20px;
}

.ifoDividerDiv {
  float: left;
  height: 5px;
  width: 100%;
  margin-bottom: 20px;
}

.ifoImg2>div {
  width: 200px;
  height: 100px;

  border-radius: 20px;
  margin-left: 20px;
}

.listImg {
  background-color: #fff;
  margin-top: 20px;
  height: 230px;

  .pic {
    display: flex;

    .content {
      padding: 24px 0 0 0px;
      display: flex;
      flex-direction: column;
      row-gap: 8px;

      .title {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #252628;
        line-height: 20px;
      }

      .ifoImg2 {
        width: 200px;
        height: 100px;
        border-radius: 4px;
        border: 1px solid #DFE0E2;
      }
    }

    .picStyle {
      width: 112px;
      height: 100px;
      margin: 53px 5px 0 -52px;
    }
  }


}

.setting {
  height: 450px;
  margin-top: 20px;
  background-color: #fff;
}

.settingContent {
  padding-top: 8px;
  width: 100%;
  height: 300px;
  display: flex;
  padding-right: 16px;
}

.settingContent>div {
  float: left;
}

.settingContent>div:nth-child(1) {
  width: 345px;
  background-color: #fff;
  height: 317px;
  border-radius: 10px;
  border: 2px solid #e9eaeb;
  margin-left: 20px;
}

.settingWord {
  height: 42px;
  width: 80%;
  line-height: 40px;
  border-radius: 4px;
  border: 2px solid #e9eaeb;
  margin-left: 20px;
  /* background-color: rgba(232, 240, 250, 1); */
  margin-top: 9px;
}

.settingWord>span:nth-child(1) {
  padding: 0 20px;
}

.settingWord:hover {
  background: #DFE0E2FF;
}

.settingRight {
  width: 60%;
  background-color: #E5E5E5;
  height: 318px;
  margin-left: 20px;
  border: 2px solid #e9eaeb;
  border-radius: 10px;
}

.settingRightContentone {
  width: 26px;
  height: 17px;
  background: #1c69d4;
  border-radius: 4px 0px 4px 0px;
  margin-top: 0px;
  margin-left: 0px;
  color: white;
  text-align: center;
}

.settingRightContentones {
  display: flex;
  margin-left: 21px;
}

.settingRightContentTwo {
  width: 50%;
  height: 20px;
  background: rgba(28, 105, 212, 0.08);
  border-radius: 2px;
  text-align: -webkit-center;
  margin-top: -2px;
  margin-left: 5px;
  white-space: nowrap;
}

.settingRightContentThree {
  width: 24px;
  height: 20px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-weight: 500;
  color: #1c69d4;
  line-height: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.settingRightContentFour {
  margin-left: 20px;

  .tag-style {
    width: 37px;
    height: 17px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #999A9C;
    line-height: 17px;
  }
}

.settingRightContentImg {
  width: 116px;
  height: 48px;
  background: #edf3fc;
  border-radius: 4px;
  margin-left: 20px;

  img {
    width: 100%;
    height: 66%;
    object-fit: contain;
    margin-top: 10px;
  }
}

.settingRightContent {
  width: 156px;
  height: 231px;
  margin: 23px 23px;
  background: #ffffff;
  border-radius: 4px;
  float: left;
  display: grid;
}

// .settingRightContent > div {
//   margin: 5px 25px;
// }
// .settingRightContent2 > div {
//   margin-top: 5px;
// }
.settingRightContent>div>span:nth-child(1) {
  color: #a5a5a7;
}
.courseRecommendListStyle{
  display: flex;
  width: 90%;
  .hideCourseName{
        overflow: hidden;
        text-overflow: ellipsis;
        width: 188px;
        cursor:pointer;
        white-space: nowrap;
  }
}
.introContent {
  width: 250px;
  margin-left: 20px;
  padding-top: 16px;
}

.introImg {
    width: 200px;
    height: 101px;
    border-radius: 4px;
    border: 1px solid #dfe0e2;
    background-size: 100% 100%;
}

.intro {
  width: 100%;
  height: 350px;
  background-color: #fff;
  margin-top: 20px;
}

.introShuxing>div {
  margin-top: 10px;
}

.introShuxing>div>span {
  float: left;
}

.introShuxing>div>span:nth-child(1) {
  width: 70px;
  display: block;
  text-align: justify;
  text-align-last: justify;
  color: #a5a5a7;
}

.introShuxing>div>span:nth-child(2) {
  margin-left: 3px;
}

.introContent {
  float: left;
  margin-right: -39px;
}

.question {
  width: 100%;
  height: 500px;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
}

.questionContent {
  margin-left: 20px;
  max-height: 500px;
  padding-top: 3px;
}

.questionButton {
  margin-right: 29px;
  float: right;
  margin-top: -8px;
  background-color: #1c69d4;
  border-radius: 3px !important;
}

.ifoDivider {
  height: 1px;
}

.contenttest {
  width: 596px;
  height: 132px;
  margin-left: 120px !important;
  background: #f2f4f5;
  border-radius: 4px;
  opacity: 0.5;
  border: 1px solid #dfe0e2;
}

 .el-table {
  tr th,
  tr td {
    border-right: none;
  }
}

.el-table::before {
  height: 0px;
}

 ::-webkit-scrollbar {
  width: 7px;
  margin-top: 10px;
  height: 8px;
  outline: none;
  border: 0 none;
  background-color: rgba(255, 255, 255, 0.5) !important;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: rgba(255, 255, 255, 0.5) !important;
  -webkit-box-shadow: rgba(255, 255, 255, 0.5) !important;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5) !important;
}

// /*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}

.text_273 {
  width: 42px;
  height: 20px;
  color: rgba(37, 38, 40, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.contentdide {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 140px;
}

.contenthide {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 147px;
}

.contentdide:hover {
  // show-overflow-tooltip
}

.typeGold {
  width: 60px;
  height: 24px;
  background: rgba(28, 105, 212, 0.08);
  border-radius: 3px;
}

.typeSt {
  width: 28px;
  height: 12px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-weight: 500;
  color: #1c69d4;
  line-height: 12px;
  text-align: center;
  margin-top: 5px;
  margin-left: 5px;
}

.contenthides {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 131px;
}

.hides {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 137px;
  cursor: pointer;
  white-space: nowrap;
}

.ask-class {
  white-space: pre-line;
  max-width: 338px;
  height: 132px;
  background: #f2f4f5;
  border-radius: 4px;
  border: 1px solid #dfe0e2;
  overflow: hidden;
  overflow-y: scroll;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  font-weight: 400;
  color: #252628;
  padding: 0 16px;
  line-height: normal;

  .ask-content {
    margin-top: -11px;
  }
}

.question-class {
  white-space: pre-line;
  max-width: 564px;
  height: 132px;
  background: #f2f4f5;
  border-radius: 4px;
  border: 1px solid #dfe0e2;
  overflow: hidden;
  overflow-y: scroll;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  font-weight: 400;
  color: #252628;
  padding: 0 16px;
  line-height: normal;

  .question-content {
    margin-top: -11px;
  }
}

.el-dialog {
  margin-top: 29vh;
  width: 25%;
}

.dialog-modl {
  height: 19px;
  display: flex;
  align-content: center;

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    margin-left: 9px;
    margin-top: -18px;
  }

  .dialog-modl-right {
    margin-top: -29px;
    width: 280px;
    height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-weight: 550 !important;
    color: #252628;
    line-height: 24px;
  }
}

.tip {
  margin: 10px 0 0 40px;
  font-size: 18px;
}

.dialog-footer {
  padding-right: 30px;

  .dialog-footer-btn {
    margin-bottom: 28px;
  }
}



.courseIfo-moudle {
  height: 100% !important;
  padding-bottom: 18px;

  .courseIfo-moudle-header {
    text-align: center;
    display: flex;
    align-items: center;
    margin: 24px 0 0 38px;

    .moudleone-btn {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      width: 66px;
      height: 28px;
      background: #185DBDFF;
      border-radius: 4px 0px 0px 0px;
      border: 1px solid #dfe0e2;
    }

    .moudleoneT-btn {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      width: 66px;
      height: 28px;
      background: #ffffff;
      border-radius: 4px 0px 0px 0px;
      border: 1px solid #dfe0e2;
    }

    .moudleoneT-btn:hover {
      background: #2878E8;
      color: #ffffff;
    }

    .moudletwo-btn {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      width: 69px;
      height: 28px;
      background: #ffffff;
      border-radius: 0px 4px 0px 0px;
      border: 1px solid #dfe0e2;

    }

    .moudletwo-btn:hover {
      background: #2878E8;
      color: #ffffff;
    }

    .moudletwoT-btn {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      width: 69px;
      height: 28px;
      background: #185DBDFF;
      border-radius: 0px 4px 0px 0px;
      border: 1px solid #dfe0e2;

    }

  }

  .courseIfo-moudle-content {
    width: 816px;
    height: 100%;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #dfe0e2;
    margin-left: 38px;
    margin-bottom: 10px;
    padding-bottom: 29px;

    // 图片
    // 内容
    .content-all-content {
      display: flex;
      margin: 21px 0 21px 21px;

      column-gap: 14px;

      .content-content {
        width: 596px;
        height: 132px;
        background: #F2F4F5;
        border-radius: 4px;
        border: 1px solid #DFE0E2;
      }

    }

    .content-all-title {
      display: flex;
      margin: 21px 0 21px 49px;

      align-items: center;
      column-gap: 14px;

      .title {
        width: 28px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999A9C;
        line-height: 20px;
      }

      .title-content {
        width: 596px;
        height: 32px;
        background: #f2f4f5;
        border-radius: 4px;
        border: 1px solid #dfe0e2;
      }
    }
  }
}

.el-rowStyle {
  padding: 24px 24px 0 35px
}
</style>
<style lang="scss">
// 时间样式
.showInnerDia {
  width: 541px !important;
  height: 430px;
  background: #ffffff;
  border-radius: 8px;
  .line {
    margin-top: 5px;
  }
  .el-button {
    border-radius: 4px !important;
  }
  .el-input__count {
    margin-right: -7px;
    margin-bottom: -3px;
  }
  .teamtopstyle {
    display: flex;
    margin: -37px 0 14px 1px;
  }
  .el-textarea__inner {
    resize: none !important;
  }
  .message-father {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  }
  .contentHeader {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .btn-textPub {
      padding-top: 8px;
      display: flex;
      justify-content: flex-end;
      border-radius: 4px !important;
    }
    .title-text-area {
      margin-top: 10px;
      width: 84px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #252628;
      line-height: 20px;
    }
    .content-content-main {
      width: 500px;
      margin-left: 0px;
    }
    .title {
      width: 360px;
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #252628;
      line-height: 22px;
    }

    .message-y {
      width: 388px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #5a5c60;
      line-height: 20px;
    }
    .message-n{
      width: 388px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #5a5c60;
      line-height: 20px;
    }
  }
}

// 下架弹窗样式
.dropdown-dialog {
  width: 360px !important;
  height: 172px;
  background: #FFFFFF;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  .el-dialog__headerbtn {
    margin: -14px -13px 0px 0;
  }
  .el-dialog {
    margin-top: 29vh;
    width: 25%;
  }
  .dialog-modl {
    height: 19px;
    display: flex;
    align-content: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      margin-left: 0px;
      margin-top: -51px;
    }
    .dialog-modl-right {
      margin-top: -28px;
      width: 280px;
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 550 !important;
      color: #252628;
      line-height: 24px;
    }
  }
  .tip {
    margin: -13px 3px 0 30px;
    width: 280px;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #252628;
    line-height: 24px;
  }
  .dialog-footer {
    padding-right: 30px;
    .dialog-footer-btn-n {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #FFFFFF;
      border: 1px solid #DFE0E2;
    }
    .dialog-footer-btn-y {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #1C69D4;
    }
  }
}

// 删除弹窗提示
.delete-dialog {
  width: 360px !important;
  height: 172px;
  background: #FFFFFF;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  .el-dialog__headerbtn {
    margin: -14px -13px 0px 0;
  }
  .el-dialog {
    margin-top: 29vh;
    width: 25%;
  }
  .dialog-modl {
    height: 19px;
    display: flex;
    align-content: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      margin-left: 0px;
      margin-top: -51px;
    }
    .dialog-modl-right {
      margin-top: -28px;
      width: 280px;
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 550 !important;
      color: #252628;
      line-height: 24px;
    }
  }
  .tip {
    margin: -13px 3px 0 30px;
    width: 280px;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #252628;
    line-height: 24px;
  }
  .dialog-footer {
    padding-right: 30px;
    .dialog-footer-btn-n {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #FFFFFF;
      border: 1px solid #DFE0E2;
    }
    .dialog-footer-btn-y {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #1C69D4;
    }
  }
}
.course-info-content {
  .el-table th {
    border: none !important;
  }
}
</style>
